import { get, post, del } from "../common/apiClient";

const PATH_COURSE = "/course";

const createCourse = async (body) => {
  return await post(PATH_COURSE, body);
};

const getCourses = async (pageNumber, limit = 6, searchQuery) => {
  let query = `?page=${pageNumber}&limit=${limit}`;
  if (searchQuery) {
    query += `&query=${searchQuery}`;
  }
  return await get(PATH_COURSE + query);
};

const deleteCourse = async (courseId) => {
  return await del(PATH_COURSE + `/${courseId}`);
};

const getCourseStats = async () => {
  return await get(PATH_COURSE + `/stats`);
};

export { createCourse, getCourses, deleteCourse, getCourseStats };
